// @flow

import styled from 'styled-components';
import colors from 'styles/colors';

const Organization = styled.div`
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: ${(props) => props.color};
`;

Organization.Griditem = styled.div`
    display: grid;
    grid-template-columns: repeat(${(props) => props.rowSpan}, 1fr);
    height: 100%;
    grid-column-gap: 15px;
    grid-template-rows: ;
`;

Organization.empty = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
`;

Organization.trajet = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
    margin-left: 343px;
`;

Organization.entranceDate = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
    margin-left: 0px;
`;

Organization.geoName = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
`;

Organization.dateSortie = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
    margin-left: 0px;
`;

Organization.timeSpent = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
    margin-left: 55px;
`;

Organization.driverName = styled.div`
    display: flex;
    align-items: normal;
    min-width: 0;
    margin-left: 70px;
`;
Organization.Image = styled.img`
    margin-left: 10px;
    margin-right: 15px;
    width: ${(props) => props.width || '41px'};
    height: ${(props) => props.width || '41px'};
`;

export default Organization;
